import cn from "classnames";
import { FC } from 'react';
import { Text } from "../Text";

type TooltipProps = {
  label: string;
}

export const Tooltip: FC<TooltipProps> = ({ label }) => {
  return (
    <span
      aria-hidden
      className={cn(
        "pointer-events-none absolute left-1/2 top-full z-10 mt-1 -translate-x-1/2",
        "flex flex-col items-center whitespace-nowrap",
        "opacity-0 transition-opacity duration-150",
        "group-hover:opacity-100 group-focus-within:opacity-100",
      )}
    >
      <div className="relative flex flex-col items-center">
        <svg
          className="block shrink-0 text-gray-900"
          width={10}
          height={5}
          viewBox="0 0 10 5"
          aria-hidden
        >
          <path d="M5 0L10 5H0L5 0Z" fill="currentColor" />
        </svg>
        <div className="-mt-px rounded-[6px] bg-gray-900 p-1">
          <Text type="caption2" className="text-white">
            {label}
          </Text>
        </div>
      </div>
    </span>
  )
}
